import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Content from './Content';
import ScormContentView from './scorm-content-view/ScormContentView';
import QuestionEditor from './QuestionEditor';

export default () => {
    return (
        <Routes>
            <Route path="/" element={<Content />} />
            <Route path="question-editor/:questionId" element={<QuestionEditor />} />
            <Route path="question-editor" element={<QuestionEditor />} />
            <Route path=":scormId" element={<ScormContentView />} />
        </Routes>
    );
};
